<template>
  <!--用户信息-->
  <div>
    <div class="goods-head clearfloat">
      <div class="slider-list">
        <div class="item selected">用户信息</div>
      </div>
      <div class="goods-right">
        <div class="goods-right-type">
          密码强度：
          <el-tooltip
            class="item"
            effect="light"
            :content="addPopData.showPwdLevel"
            placement="right-start"
          >
            <span>{{ addPopData.showPwdLevel }}</span>
            <!-- <span v-if="addPopData.pwdLevel==1">强</span>
            <span v-if="addPopData.pwdLevel==2">中</span>
            <span v-if="addPopData.pwdLevel==3">弱</span>
            <span v-else>强</span>-->
          </el-tooltip>
        </div>
        <div class="goods-right-time">
          登录时间：
          <span>{{ userInfo.logDate }}</span>
        </div>
      </div>
    </div>
    <div v-loading="loading" class="main">
      <el-form
        ref="goodsForm"
        :model="addPopData"
        :rules="rules"
        label-position="right"
        label-width="7rem"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="头像">
              <div class="portrait" @mouseover="uploaderTipsOver" @mouseleave="uploaderTipsOut">
                <!--<g-upload is-edit :limit="1" :method-name="'logoFile'" multiple :img-list.sync="addPopData.avatar" />-->
                <!--:file-list="{name: addPopData.avatar, url: `${download}${addPopData.avatar}`}"-->
                <el-upload
                  class="avatar-uploader"
                  action
                  list-type="picture-card"
                  :http-request="upload"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload"
                  :on-success="handleAvatarSuccess"
                >
                  <!--{{ addPopData.avatar }}-->
                  <img :src="addPopData.avatar | getImg" class="avatar">
                  <!--<i v-else class="el-icon-plus avatar-uploader-icon" />-->
                  <div v-if="uploaderTips" class="avatar-uploader-tips">修改头像</div>
                </el-upload>
              </div>
              <div class="portrait-type-wrap">
                <div v-if="addPopData.authStatus!=2" class="portrait-type">
                  资质未认证
                  <span @click="qualification">立即认证</span>
                </div>
                <div v-if="addPopData.authStatus==2" class="portrait-type">
                  <span>已认证成功</span>
                </div>
                <div class="portrait-jpg">只能上传jpg/png文件，且不超过2M</div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="昵称" prop="nickName">
              <el-input v-model="addPopData.nickName" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="昵称">
              <el-input v-if="nicknameIf===true" v-model="addPopData.nickName" style="width: 325px;float: left" />
              <div v-if="nicknameIf===true" class="nickname-preservation" @click="nicknameSureClick">保存</div>
              <div v-if="nicknameIf===false" class="nickname">{{ addPopData.nickName }}</div>
              <div v-if="nicknameIf===false" class="nickname-modify" @click="nicknameClick"><i class="iconfont iconqianbi" />修改</div>
            </el-form-item>
          </el-col>
        </el-row>-->
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="addPopData.sex">
                <el-radio v-model="addPopData.sex" label="1">男</el-radio>
                <el-radio v-model="addPopData.sex" label="2">女</el-radio>
                <!-- <el-radio v-model="addPopData.sex" label="3">保密</el-radio> -->
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="真实姓名" prop="realName">
              <el-input v-model="addPopData.realName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系电话">
              <el-input v-model="addPopData.phone" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系邮箱" prop="email">
              <el-input v-model="addPopData.email" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="所属公司">
              <el-input v-model="addPopData.companyName" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="注册时间">
              <el-date-picker
                v-model="addPopData.createDate"
                type="datetime"
                :editable="false"
                disabled
                placeholder="选择日期时间"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="用户类型">
              <el-select v-model="addPopData.userType" disabled placeholder="请选择">
                <el-option label="货源方" value="1" />
                <el-option label="运力方" value="2" />
                <el-option label="仓储方" value="3" />
                <el-option label="需求方" value="4" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item
              v-if="isShow==1 && addPopData.companyName!=''"
              prop="mainBusiness"
              label="主营业务"
            >
              <el-input v-model="addPopData.mainBusiness" class="mainBusiness" maxlength="201" type="textarea" />
            </el-form-item>
            <el-form-item v-if="isShow==0" label="主营业务">
              <el-input
                v-model="addPopData.mainBusiness"
                disabled
                class="mainBusiness"
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item v-if="isShow==1 && addPopData.companyName!=''" label="公司地址">
              <el-input
                v-model="addPopData.companyAddressLabel + addPopData.detailsAddress"
                disabled
              />
            </el-form-item>
            <el-form-item v-if="isShow==0" label="公司地址">
              <el-input
                v-model="addPopData.companyAddressLabel + addPopData.detailsAddress"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div
          class="main-pop-btn"
          :class="{disabled: !this.canClick}"
          @click="mainSubmission('goodsForm')"
        >{{ content }}</div>
      </el-form>
    </div>
  </div>
</template>
<script>
import * as get from '@/api/personal/user/user-info/index.js'
import { upload } from '@/api/common/index.js'
import { mapGetters } from 'vuex'
export default {
  name: 'UserInfo',
  data() {
    return {
      // 新增业务数据
      addPopData: {
        avatar: '', // 头像
        nickName: '', // 昵称
        sex: 1, // 性别
        realName: '', // 真实姓名
        phone: '', // 联系电话
        email: '', // 联系邮箱
        companyName: '', // 所属公司
        createDate: '', // 注册时间
        userType: '', // 用户类型
        mainBusiness: '', // 主营业务
        companyAddress: '' // 公司地址
      },
      content: '提交',
      totalTime: 10,
      canClick: true, // 添加canClick
      loading: false,
      nicknameIf: false,
      // 长传图片划入状态
      uploaderTips: false,
      // 图片地址
      imageUrl: '',
      // 管理员状态
      isShow: 0,
      // 正则验证
      rules: {
        // 姓名
        realName: [
          { max: 25, message: '长度最多为25个字符' },
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { validator: this.$validate('names') }
        ],
        // 昵称
        nickName: [
          { max: 20, message: '长度最多为20个字符' },
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { validator: this.$validate('nickname') }
        ],
        // 性别
        sex: [{ required: true, message: '请选择性别' }],
        // 邮箱
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { max: 50, message: '邮箱长度最多为50个字符' },
          { validator: this.$validate('email') }
        ],
        // 主营业务
        mainBusiness: [{ max: 201, message: '最多为200个字符' }],
        phone: [
          { required: false, message: '请输入手机号', trigger: 'blur' },
          { validator: this.$validate('phone') }
        ],
        code: [
          { required: false, message: '请输入验证码', trigger: 'blur' },
          { validator: this.$validate('code') }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    console.log(this.userInfo)
    this.isShow = this.userInfo.isAdmin
    this.loading = true
    get
      .getInformation({
        userId: this.userInfo.userId
      })
      .then(res => {
        const odata = res.result
        this.addPopData = odata
        console.log(odata)
        // this.addPopData.nickName = odata.nickName
        // this.addPopData.sex = odata.sex
        // this.addPopData.realName = odata.realName
        // this.addPopData.phone = odata.phone
        // this.addPopData.email = odata.email
        // this.addPopData.companyName = odata.companyName
        // this.addPopData.createDate = odata.createDate
        // this.addPopData.userType = odata.userType
        // this.addPopData.mainBusiness = odata.mainBusiness
        // this.addPopData.companyAddress = odata.companyAddress
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loading = false
      })
  },
  mounted() {},
  methods: {
    // 上传头像划入
    uploaderTipsOver() {
      this.uploaderTips = true
    },
    // 上传头像移出
    uploaderTipsOut() {
      this.uploaderTips = false
    },
    // 上传成功后
    handleAvatarSuccess(res, file) {
      setTimeout(() => {
        this.addPopData.avatar = res.fileId
      }, 1000)
    },
    beforeAvatarUpload(file) {
      console.log(file)
      const isJPG =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG PNG 格式!')
        return isJPG
      } else if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
        return isLt2M
      }
    },
    // 自定义上传方法
    upload(options) {
      const formData = new FormData()
      formData.append('file', options.file)
      upload(
        {
          data: formData,
          methodName: 'logoFile'
        },
        {
          // 添加上传进度条
          onUploadProgress: progressEvent => {
            const complete =
              ((progressEvent.loaded / progressEvent.total) * 100) | 0
            options.onProgress({ percent: complete })
          }
        }
      )
        .then(res => {
          options.onSuccess({ fileId: res.fileId }) // 上传成功出现成功提示，同时把id传入
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 提交
    mainSubmission() {
      this.$refs['goodsForm'].validate(valid => {
        // console.log(valid)
        if (valid) {
          // console.log(this.addPopData)
          var params = JSON.parse(JSON.stringify(this.addPopData))
          if (params.avatar) {
            if ((typeof params.avatar) != 'string') {
              params.avatar = params.avatar.join(',')
            }
          }
          if (!this.canClick) return
          this.canClick = false
          this.content = this.totalTime + 's后点击'
          const clock = window.setInterval(() => {
            this.totalTime--
            this.content = this.totalTime + 's后点击'
            if (this.totalTime < 0) {
              window.clearInterval(clock)
              this.content = '提交'
              this.totalTime = 10
              this.canClick = true // 这里重新开启
            }
            return
          }, 1000)
          get
            .editInformation(params, { userId: this.userInfo.userId })
            .then(res => {
              // console.log(res)
              if (res.code == 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
              } else {
                this.$message({
                  message: '修改失败',
                  type: 'error'
                })
              }
            })

            .catch(error => {
              console.log(error)
            })
        } else {
          return false
        }
      })
    },
    // 资质认证跳转
    qualification() {
      this.$router.push({
        name: 'QualificationsAuthen'
      })
    }
    // // 昵称修改按钮
    // nicknameClick() {
    //   this.nicknameIf = true
    // },
    // // 昵称保存按钮
    // nicknameSureClick() {
    //   this.nicknameIf = false
    // }
  }
}
</script>
<style scoped lang='scss'>
$main-color: #be2316;
.goods-head {
  padding: 12px 12px 0 12px;
  box-sizing: border-box;
  border-style: solid;
  border-color: #f1f1f1;
  background-color: #ffffff;
  width: 928px;
  height: 49px;
  border-bottom: 1px solid #f1f1f1;

  .slider-list {
    display: block;
    width: 60%;
    margin: 0 0;
    height: 36px;
    float: left;
    overflow: auto;
    white-space: nowrap;
    &::-webkit-scrollbar {
      height: 0px !important;
      width: 0px !important;
    }
    &::-moz-scrollbar {
      height: 0px !important;
      width: 0px !important;
    }
    .item {
      // height: 35px;
      height: calc(100% - 1px);
      display: inline-block;
      width: 100px;
      font-size: 16px;
      font-weight: 600;
      line-height: 35px;
      margin-right: 12px;
      border-bottom: 1px solid rgba(0, 0, 0, 0);
      text-align: center;
      transition: all 1s;
      color: black;
      cursor: pointer;

      &.selected {
        border-bottom: 1px solid $main-color;
        transition: all 1s;
        color: $main-color;
      }
    }
  }
  .goods-right {
    float: left;
    width: 40%;
    height: 36px;
    line-height: 26px;
    .goods-right-type {
      float: left;
      font-size: 14px;
      color: #666666;
      span {
        color: #4caf50;
      }
    }
    .goods-right-time {
      float: right;
      color: #959595;
      font-size: 14px;
    }
  }
}
.main {
  width: 100%;
  padding: 20px 30px 20px 0px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border-color: #f1f1f1;
  background-color: #ffffff;

  .nickname {
    float: left;
    color: #2e2e2e;
    font-size: 14px;
    margin-right: 20px;
  }
  .nickname-modify {
    float: left;
    cursor: pointer;
    color: #e84809;
    i {
      vertical-align: middle;
    }
  }
  .nickname-preservation {
    float: left;
    width: 70px;
    height: 39px;
    font-size: 14px;
    border-radius: 4px;
    background: #be2316;
    text-align: center;
    line-height: 40px;
    margin-left: 5px;
    cursor: pointer;
    color: #fff;
  }
  .portrait {
    float: left;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    .avatar-uploader {
      position: relative;
      width: 100px;
      height: 100px;
      img {
        width: 100px;
        height: 100px;
      }
      /deep/.el-upload.el-upload--picture-card {
        border: none;
      }
      /deep/.el-upload {
        width: 100px !important;
        height: 100px !important;
        line-height: 100px;
        /*<!--width: 99px !important;-->*/
        /*<!--height: 99px !important;-->*/
        /*<!--line-height: 100px;-->*/
        /*<!--overflow: hidden;-->*/
        /*<!--margin-top: -1px;-->*/
        /*<!--margin-left: -1px;-->*/
      }
      .avatar-uploader-tips {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        line-height: 100px;
        font-size: 14px;
        background: rgba(000, 000, 000, 0.5);
        cursor: pointer;
        color: #fff;
      }
    }
  }
  .portrait-type-wrap {
    float: left;
    .portrait-type {
      font-size: 14px;
      color: #cdcdcd;
      margin-left: 15px;
      span {
        /* cursor: pointer; */
        font-size: 14px;
        color: #2e8bff;
        margin-left: 15px;
      }
    }
    .portrait-jpg {
      font-size: 12px;
      padding-left: 30px;
      color: #606266;
      margin-top: 15px;
    }
  }
  .main-pop-btn {
    width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin: 0 auto;
    background: rgba(190, 35, 22, 1);
    border-radius: 4px;
    color: #ffffff;
    font-size: 18px;
    cursor: pointer;
  }
   .disabled {
    background-color: #ddd;
    border-color: #ddd;
    color: #fff;
    cursor: not-allowed; // 鼠标变化
  }
  .mainBusiness {
    /deep/.el-textarea__inner {
      height: 152px;
    }
  }
}

.el-select,
.el-cascader {
  width: 100% !important;
}
/deep/ .el-date-editor.el-input {
  width: 100% !important;
}
/deep/.el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 106px;
  height: 106px;
  line-height: 110px;
  vertical-align: top;
}
/deep/.el-upload-list--picture-card .el-upload-list__item {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 106px;
  height: 106px;
  margin: 0 8px 8px 0;
  display: inline-block;
}
/deep/.el-upload {
  &.el-upload--picture-card {
    /*overflow: hidden;*/
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
